import styled from 'styled-components';

const StyledQueryItem = styled.div`
  display: block;
`;

const StyledQueryGroup = styled.div`
  position: relative;
`;

const StyledQueryGroupList = styled.div`
  &:before {
    content: '${props => (props.showBrackets ? '(' : '')}';
    display: block;
    color: ${props => props.color};
  }

  &:after {
    content: '${props => (props.showBrackets ? ')' : '')}';
    display: block;
    color: ${props => props.color};
  }

  ${StyledQueryItem}, ${StyledQueryGroup} {
    padding-left: ${props =>
      props.showBrackets ? props.theme.spacing.medium : 0};
  }
`;

export { StyledQueryGroup, StyledQueryGroupList, StyledQueryItem };
